import React from 'react';

import Head from 'next/head';

import { withEventScope } from '@repo/event-processor';
import { buildWebsiteUrl } from '@repo/utils/url';

import Layout from 'components/Layout/Layout';
import { reactComponentByType } from 'strapi/component';

import { LandingPageStrapiProps } from './types';

const LandingPageStrapi: React.FC<LandingPageStrapiProps> = ({ params }) => {
  return (
    <Layout newBackground={true}>
      <Head>
        {/* Facebook, Open Graph protocol */}
        <meta key="og:type" content="article" property="og:type" />
        <meta key="og:url" content={buildWebsiteUrl()} property="og:url" />
      </Head>
      {params.map(({ component, props }, index) => {
        const Component = reactComponentByType[component];
        // @ts-expect-error: TODO: types mismatch
        return <Component key={index} {...props} />;
      })}
    </Layout>
  );
};
export default withEventScope(LandingPageStrapi, { page: 'landingPage' });
